import { Record } from 'immutable'

import { OrganizationsPermissions } from './record'

const OrganizationPublicInfoRecord = Record(
  {
    id: '',
    name: '',
    domain: '',
    photoURL: null,
    product: null,
    authMethod: null,
    authDomains: null,
    featureFlags: '',
    membersCanAutoJoin: false,
    authProvider: null,
    // permissions will not get fetched but having them here ensure we have the default ones
    permissions: OrganizationsPermissions(),
  },
  'organizationPublicInfo'
)

class OrganizationPublicInfo extends OrganizationPublicInfoRecord {
  getPhotoUrl() {
    return this.photoURL
  }
}

export default OrganizationPublicInfo

export function createFromRaw(rawOrganization) {
  return new OrganizationPublicInfo(rawOrganization)
}
